import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import {useState} from "react";
import {MultiMediaService} from "./MultiMediaService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import RaikoCustomAparatInput from "../../raikoComponents/raikoCustomAparatInput/RaikoCustomAparatInput";

export default function MultiMediaAddNewItem({handleCloseDialog, handleAddNewItem}) {

    const service = new MultiMediaService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [title, setTitle] = useState("");
    const [videoLink, setVideoLink] = useState('');

    function handleAdd() {
        if (title.length > 0 && videoLink.length > 0) {
            loading.show()
            service.addNewItemToServer(title, videoLink)
                .then(response => {
                    handleAddNewItem(response)
                    snackbar.showSuccessMessage("ویدیو جدید با موفقیت افزوده شد.")
                    loading.hide()
                    handleCloseDialog()
                }).catch(reason => {

                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در افزودن ویدیو جدید."))
                loading.hide()
            })
        } else
            snackbar.showWarningMessage("لطفا عنوان و لینک ویدیو را به درستی وارد نمایید.")
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoSimpleInputOutlined labelText={"عنوان"} setValue={setTitle} value={title}/>
            <RaikoCustomAparatInput
                link={videoLink}
                changeLink={setVideoLink}
            />
            <ButtonDivisionSection>
                <ButtonPrimaryRaiko label={"افزودن"} onClick={handleAdd}/>
            </ButtonDivisionSection>
        </RaikoGridOneColumn>
    )
}